import { ELocationType } from '~/features/agents/models'

export enum ELocationFormKeys {
  name = 'name',
  streetAddress1 = 'streetAddress1',
  streetAddress2 = 'streetAddress2',
  city = 'city',
  state = 'state',
  zipCode = 'zipCode',
  timezone = 'timezone',
  hoursText = 'hoursText',
  type = 'type',
}

export type TLocationForm = {
  [ELocationFormKeys.name]: string
  [ELocationFormKeys.streetAddress1]: string | null
  [ELocationFormKeys.streetAddress2]: string | null
  [ELocationFormKeys.city]: string | null
  [ELocationFormKeys.state]: string | null
  [ELocationFormKeys.zipCode]: string | null
  [ELocationFormKeys.timezone]: string | null
  [ELocationFormKeys.hoursText]: string | null
  [ELocationFormKeys.type]: ELocationType | string
}

export enum EAddLocationsFormKeys {
  numberOfLocations = 'numberOfLocations',
  locations = 'locations',
}

export type TAddLocationForm = TLocationForm & {
  agentIds: string[]
}

export type TAddLocationsForm = {
  [EAddLocationsFormKeys.numberOfLocations]: string | number
  [EAddLocationsFormKeys.locations]: TAddLocationForm[]
}
